module.exports = __webpack_public_path__ + "static/media/37.4a361cb9.jpg";